/* Copia del master SETUP/kit-moduli/campi.js (16/10/2026) per il modulo preventivo di WIVI: non si modifica qui, si aggiorna dal master. */
/**
 * Campi coerenti col loro tipo: MASTER in SETUP/kit-moduli/ (nato su Iredeem · Ruota della fortuna, 05/10/2026).
 * Rami: «se scrivo lettere nel campo telefono me le fa scrivere ma non dovrei poterlo fare».
 * Ogni input con data-filtro accetta SOLO i caratteri del suo tipo mentre si scrive (il cursore resta dov'era),
 * e window.CAMPI.errore(tipo, valore) dà il formato da controllare all'uscita dal campo e all'invio.
 * Il server ripete gli stessi controlli (campi.php di questo kit): questo è comodità, non sicurezza.
 * Regole e tabella dei tipi: LEGGIMI.md.
 */
(function () {
	'use strict';

	var EMAIL = /^[A-Za-z0-9._%+'-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/;

	/** Cosa resta di un valore, carattere per carattere, per ogni tipo. */
	var FILTRI = {
		telefono: function (v) {
			// cifre e spazi; il + solo come primo carattere
			return v.replace(/[^\d+ ]/g, '').replace(/(?!^)\+/g, '');
		},
		email: function (v) {
			var s = v.replace(/[^A-Za-z0-9.!#$%&'*+\/=?^_`{|}~@-]/g, '');
			var i = s.indexOf('@');
			return i === -1 ? s : s.slice(0, i + 1) + s.slice(i + 1).replace(/@/g, '');
		},
		cap: function (v) {
			return v.replace(/\D/g, '').slice(0, 5);
		},
		provincia: function (v) {
			return v.replace(/[^A-Za-z]/g, '').toUpperCase().slice(0, 2);
		},
		nome: function (v) {
			// lettere (anche accentate), spazi, apostrofi, trattini, punti: «D'Angelo», «Rossi-Bianchi», «S. Giovanni»
			return v.replace(/[^\p{L}\s'’.\-]/gu, '');
		},
		piva: function (v) {
			return v.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 16);
		},
		cf: function (v) {
			return v.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 16);
		},
		sdi_pec: function (v) {
			// codice SDI (7 caratteri) oppure una PEC: niente spazi
			var s = v.replace(/\s/g, '');
			return s.indexOf('@') === -1 ? s.toUpperCase() : FILTRI.email(s);
		}
	};

	/** Il formato, quando il campo non è vuoto. Ritorna il codice dell'errore o ''. */
	function errore(tipo, v) {
		v = (v || '').trim();
		if (!v) {
			return '';
		}
		switch (tipo) {
			case 'telefono':
				var cifre = v.replace(/\D/g, '').length;
				return cifre >= 6 && cifre <= 15 ? '' : 'telefono';
			case 'email':
				return EMAIL.test(v) ? '' : 'email';
			case 'cap':
				return /^\d{5}$/.test(v) ? '' : 'cap';
			case 'provincia':
				return /^[A-Z]{2}$/.test(v) ? '' : 'provincia';
			case 'nome':
				return /\p{L}/u.test(v) ? '' : 'nome';
			case 'piva':
				return /^(IT)?\d{11}$/.test(v) || /^(?!IT)[A-Z]{2}[A-Z0-9]{2,13}$/.test(v) ? '' : 'piva';
			case 'cf':
				return /^[A-Z]{6}[A-Z0-9]{2}[A-Z][A-Z0-9]{2}[A-Z][A-Z0-9]{3}[A-Z]$/.test(v) || /^\d{11}$/.test(v) ? '' : 'cf';
			case 'sdi_pec':
				return /^[A-Z0-9]{6,7}$/.test(v) || EMAIL.test(v) ? '' : 'sdi_pec';
		}
		return '';
	}

	/** Applica il filtro tenendo il cursore al suo posto. */
	function filtra(input) {
		var f = FILTRI[input.getAttribute('data-filtro')];
		if (!f) {
			return;
		}
		var prima = input.value;
		var dopo = f(prima);
		if (dopo === prima) {
			return;
		}
		var pos = input.selectionStart;
		var tolti = pos === null ? 0 : prima.slice(0, pos).length - f(prima.slice(0, pos)).length;
		input.value = dopo;
		if (pos !== null && input.setSelectionRange && document.activeElement === input) {
			try {
				input.setSelectionRange(pos - tolti, pos - tolti);
			} catch (e) {
				/* type=email non sempre accetta setSelectionRange */
			}
		}
	}

	document.addEventListener('input', function (ev) {
		if (ev.target && ev.target.hasAttribute && ev.target.hasAttribute('data-filtro')) {
			filtra(ev.target);
		}
	}, true);

	window.CAMPI = { errore: errore, filtra: filtra };
})();
